import React, { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import smallimg_1 from '../../../../assets/images/New_Change_Img/1st_20min_promise.svg';
import smallimg_2 from '../../../../assets/images/New_Change_Img/2nd_20min_promise.svg';
import smallimg_3 from '../../../../assets/images/New_Change_Img/3rd_20min_promise.svg';
import smallimg_4 from '../../../../assets/images/New_Change_Img/4th_20min_promise.svg';

import './MinPromise.css';
import DashboardHeader from '../../../header/DashboardHeader';
import { Form, FormLabel } from 'react-bootstrap';
import Select from 'react-select';
import { ErrorMessage } from '@hookform/error-message';
import { addTreehouseErrors } from '../../../../constants/error.constants';
import { useForm } from 'react-hook-form';
import FormInput from '../../../common/FormInput';
import { useAuth } from '../../../auth/Auth';
import { campScheduleViewModel } from '../../camp_schedule/camp.schedule.view.model';
import timezones from 'timezones-list';
import MinPromisePopups from './MinPromisePopups';
import { useHistory } from 'react-router-dom';
import LoadButton from '../../../common/LoadButton';

const MinPromise = () => {
  const _NOT_SELECTED = '';
  const history = useHistory();
  const [day, setDay] = useState('');
  const [time, setTime] = useState('');
  const [timezone, setTimezone] = useState('');
  const [popupNumber, setPopupNumber] = useState(1);
  const [showModal, setShowModal] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const { guardian } = useAuth();
  const { dependent_id } = history?.location?.state;
  const { register, handleSubmit, setError, errors, getValues } = useForm({
    mode: 'onBlur',
  });
  const dayOptions = [
    { value: _NOT_SELECTED, label: 'Select...' },
    { value: 'sunday', label: 'Sunday' },
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 48,
      color: '#321b6d',
      fontWeight: '400',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  const handleDayChange = (selected) => {
    setDay(selected.value);
  };

  const onSubmit = () => {
    setIsLoading(true);
    const data = {
      dependent_id: dependent_id,
      guardian_id: guardian?.id,
      day: day,
      time: time,
      time_zone: timezone,
    };
    campScheduleViewModel
      .createTwentyMinPromise(data)
      .then((res) => {
        setPopupNumber(2);
        setIsLoading(false);
        setShowModal(true);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const handleTimezoneChange = (selected) => {
    setTimezone(selected.tzCode);
  };

  const handleTimeChange = (e) => {
    setTime(e.target.value);
  };

  return (
    <div
      className="guardian-setting-wrapper guardian-setting"
      id="guardian_setting"
    >
      <DashboardHeader />
      <MinPromisePopups
        showModal={showModal}
        setShowModal={setShowModal}
        popupNumber={popupNumber}
      />
      <div className="container" style={{ paddingTop: '40px' }}>
        <div className="row">
          <div className="col-md-12">
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <Typography
                  variant="h3"
                  align="left"
                  fontSize="32px"
                  fontWeight="700"
                  color="#321b6d"
                >
                  Make the 20-Minute Promise with Your Child
                </Typography>
              </Grid>
              {/* <Grid item alignItems="left" className="min_promise_videobox">
                <iframe
                  width="100%"
                  height="238"
                  src="https://www.youtube.com/embed/BnSvbzNO5s8"
                  title="TaleTree, Creator Kids&#39; Digital Haven"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </Grid> */}
              <Grid item>
                <Typography
                  variant="h5"
                  fontSize="16"
                  fontWeight="600"
                  color="#321b6d"
                >
                  Your Promise
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="p"
                  fontSize="14"
                  fontWeight="400"
                  color="#321b6d"
                >
                  Dear Taletree, I promise, for just 20 mins per week to
                  participate in TaleTree's weekly creative cycle, by setting 20
                  minutes aside every week to:
                </Typography>
              </Grid>
              <Grid item className="d-flex align-content-center">
                <img src={smallimg_1} className="mr-2 small_img_20min"></img>
                <p className="mb-0">Discuss your child’s creative journey.</p>
              </Grid>
              <Grid item className="d-flex align-content-center">
                <img src={smallimg_2} className="mr-2 small_img_20min"></img>
                <p className="mb-0">
                  Ask open-ended questions that spark their imagination.
                </p>
              </Grid>
              <Grid item className="d-flex align-content-center">
                <img src={smallimg_3} className="mr-2 small_img_20min"></img>
                <p className="mb-0">
                  Review the insights generated by their activities on TaleTree.
                </p>
              </Grid>
              <Grid item className="d-flex align-content-center">
                <img src={smallimg_4} className="mr-2 small_img_20min"></img>
                <p className="mb-0">
                  Support and encourage their unique talents and ideas.
                </p>
              </Grid>
              <Grid item>
                <Typography
                  variant="h5"
                  align="left"
                  fontSize="24"
                  fontWeight="800"
                  color="#321b6d"
                >
                  Select Your Weekly Session Time
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="p"
                  fontSize="14"
                  fontWeight="400"
                  color="#321b6d"
                >
                  Let’s make this a consistent, joyful experience. Please choose
                  a day and time each week that works best for you and your
                  child to sit down and have this enriching conversation.
                </Typography>
              </Grid>
              <Grid item sx={{ maxWidth: '400px !important' }}>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Day</Form.Label>
                  <Select
                    options={dayOptions}
                    styles={customStyles}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleDayChange}
                  />
                  <FormInput
                    type="hidden"
                    name="day"
                    value={day}
                    ref={register({
                      required: addTreehouseErrors.day.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="day"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
              </Grid>
              <Grid item sx={{ maxWidth: '400px !important' }}>
                <Form.Group className="mb-3" controlId="">
                  <FormLabel>Time</FormLabel>
                  <FormInput
                    type="time"
                    name="time"
                    className="form-input"
                    value={time}
                    onChange={handleTimeChange}
                    ref={register({
                      required: addTreehouseErrors.time.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="time"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
              </Grid>
              <Grid item sx={{ maxWidth: '400px !important' }}>
                <Form.Group className="mb-3" controlId="">
                  <Form.Label>Time zone</Form.Label>
                  <Select
                    options={timezones}
                    styles={customStyles}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: '6px',
                      colors: {
                        ...theme.colors,
                        primary: '#80e4e1',
                      },
                    })}
                    onChange={handleTimezoneChange}
                  />
                  <input
                    type="hidden"
                    name="timezone"
                    value={timezone}
                    ref={register({
                      required: addTreehouseErrors.timezone.required,
                    })}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="timezone"
                    className="small text-danger"
                    as="label"
                  />
                </Form.Group>
              </Grid>
              <Grid item>
                <Typography
                  variant="p"
                  fontSize="14"
                  fontWeight="400"
                  color="#321b6d"
                >
                  Once you’ve made your selection, this time will be added to
                  your calendar, and we’ll send you a reminder each week. Plus,
                  we’ll deliver a customized report to guide your conversation,
                  full of insights from your child’s creative activities.
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="p"
                  fontSize="14"
                  fontWeight="400"
                  color="#321b6d"
                >
                  Together, let’s make these 20 minutes a time to connect,
                  dream, and grow.
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="p"
                  fontSize="14"
                  fontWeight="400"
                  color="#321b6d"
                >
                  Yours Faithfully,
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="p" className="sigbox">
                  <p style={{ margin: '0 auto' }}>
                    {guardian?.first_name} {guardian?.last_name}
                  </p>
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="column"
              alignItems="center"
              spacing={3}
              sx={{ paddingTop: '30px' }}
            >
              <Grid item width="100%">
                <LoadButton
                  className="Yes_btn"
                  onClick={onSubmit}
                  isLoading={isLoading}
                  isDisabled={!day || !time || !timezone}
                  text="Accept Promise"
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MinPromise;
